import actionTypes from 'constants/actionTypes'
import apiURLBuilder from 'core/apiURLBuilder'
import { APIPost } from 'utilities/APIRequestHelper'

const resetAccountValidate = () => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_RESET
})

const requestAccountCancellation = () => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_REQUEST
});

const requestAccountCancellationSuccess = () => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_SUCCESS,
});

const requestAccountCancellationRejected = (response) => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_REJECTED,
  payload: {
    response
  }
});

const requestAccountCancellationFailure = (error) => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_FAILURE,
  payload: {
    error
  }
});

const validateAccountCancellation = (oldContract, newContract) => (dispatch) => {
  dispatch(requestAccountCancellation())
  const data = {
    query: {
      oldContract,
      newContract,
    },
  };

  return APIPost(dispatch, apiURLBuilder.getURL('accountCancelValidation'), data)
    .then(response => {
      if (response) {
        dispatch(requestAccountCancellationRejected(response));
        return 
      }
      dispatch(requestAccountCancellationSuccess())
    })
    .catch(error => {
      dispatch(requestAccountCancellationFailure(error))
    });
};

module.exports = {
  validateAccountCancellation,
  resetAccountValidate
};
